import React, { useState, useEffect, useRef } from 'react';
import img1 from 'assets/images/banner/card1.png';
import img2 from 'assets/images/banner/card2.png';
import img3 from 'assets/images/banner/card3.png';
import './BannerCarousel.css';

const slides = [
  { img: img3, title: 'Qualidade', subtitle: 'Produtos e serviços com precisão e excelência para superar expectativas.', link: '/link1' },
  { img: img2, title: 'PONTUALIDADE', subtitle: 'Compromisso com prazos para garantir a satisfação dos nossos clientes.', link: '/link2' },
  { img: img1, title: 'SEGURANÇA', subtitle: 'Garantimos segurança e tranquilidade em cada projeto.', link: '/link3' },
];

const AUTOPLAY_MS = 4000;

const BannerCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(1);
  const pausedRef = useRef(false);

  const prevSlide = () => setActiveIndex((prev) => (prev - 1 + slides.length) % slides.length);
  const nextSlide = () => setActiveIndex((prev) => (prev + 1) % slides.length);

  const getSlideClass = (index) => {
    if (index === activeIndex) return 'carousel-3d-slide active';
    if (index === (activeIndex - 1 + slides.length) % slides.length) return 'carousel-3d-slide prev';
    if (index === (activeIndex + 1) % slides.length) return 'carousel-3d-slide next';
    return 'carousel-3d-slide';
  };

  // autoplay
  useEffect(() => {
    const id = setInterval(() => {
      if (!pausedRef.current) nextSlide();
    }, AUTOPLAY_MS);
    return () => clearInterval(id);
  }, []); // uma vez só

  return (
    <div
      className="carousel-container"
      onMouseEnter={() => (pausedRef.current = true)}
      onMouseLeave={() => (pausedRef.current = false)}
    >
      <button className="carousel-arrow carousel-arrow--prev" onClick={prevSlide}>❮</button>

      <div className="carousel-3d">
        {slides.map((slide, index) => (
          <div key={index} className={getSlideClass(index)}>
            <img src={slide.img} alt={slide.title} />
            <div className="carousel-3d-caption">
              <h3>{slide.title}</h3>
              <p>{slide.subtitle}</p>
            </div>
          </div>
        ))}
      </div>

      <button className="carousel-arrow carousel-arrow--next" onClick={nextSlide}>❯</button>
    </div>
  );
};

export default BannerCarousel;
